var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"editButton",staticClass:"btn btn-default",attrs:{"data-toggle":"tooltip","data-container":"body","title":"Edit"},on:{"click":function($event){return _vm.goToEdit()},"mousedown":_vm.hideTooltip}},[_c('i',{staticClass:"fa fa-pencil"}),(!_vm.hideLabel)?_c('span',{staticClass:"edit-label"},[_vm._v("\nEdit")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }